import React from "react";
import "./Indications.css";
import Hero from "../components/Hero";
import Footer from "../components/Footer";
import Card from "../components/Card";
import img4 from "../assets/card4.png";
import img2 from "../assets/card2.png";
import img3 from "../assets/card3.png";
import img1 from "../assets/card1.png";
import IVFSteps from "../components/IVFSteps";
import Services from "../components/Services";
import FAQ from "../components/FAQ";
import { useTranslation } from "react-i18next";

function Home() {
	const { t } = useTranslation();

	const indications = [
        t("Indic1"),
        t("Indic2"),
        t("Indic3"),
        t("Indic4"),
        t("Indic5"),
        t("Indic6"),
    ];

	return (
		<div>
			<Hero />
			<div className="card-container">
				<Card image={img1} title={t("card1h")} text={t("card1t")} />
				<Card image={img2} title={t("card2h")} text={t("card2t")} />
				<Card image={img3} title={t("card3h")} text={t("card3t")} />
				<Card image={img4} title={t("card4h")} text={t("card4t")} />
			</div>
			<div id="Surrogate" className="image-section">
				<div className="text-content">
					<h2>{t("surTiTle")}</h2>
					<p>{t("surText1")}</p>
					<p>{t("surText2")}</p>
				</div>
			</div>
			<div id="IVF" className="indications-section">
            <h2 className="indications-title">Indications</h2>
            <div className="indications-grid">
                {indications.map((text, index) => (
                    <div className="indication-card" key={index}>
                        <div className="indication-icon">
                            <span>{index + 1}</span>
                        </div>
                        <div className="indication-content">
                            <p>{text}</p>
                        </div>
                    </div>
                ))}
            	</div>
        	</div>

			<IVFSteps />
			<div id="Services">
				<Services />
			</div>

			<div id="FAQ">
				<FAQ />
			</div>

			<Footer />
		</div>
	);
}

export default Home;
